import ConfigurableBackground from './_configurable-background.js'
import ConfigurableText from './_configurable-text.js'
import FlexPane from './_flex-pane.js'
import Button from './_button.js'
import Image from './_image.js'
import DateTime from './_date-time.js'
import Timer from './_timer.js'
import Text from './_text.js'

export default {
  name: 'RaceMeetingCoupon',
  values: {
    style: {
      allRaces: {
        container: {
          $mixin: [
            {
              configSet: ConfigurableBackground,
            },
          ],
        },
        leftInnerContainer: {
          margin: 0,
        },
        meetingName: {
          textStyles: {
            $mixin: [
              {
                configSet: ConfigurableText,
              },
            ],
          },
        },
        trackStatus: {
          textStyles: {
            $mixin: [
              {
                configSet: ConfigurableText,
              },
            ],
          },
        },
      },
      raceButtonsContainer: {
        configSet: FlexPane,
        configValues: {},
      },
      nextRace: {
        container: {
          height: '40px',
          padding: '0 6px 0 8px',
          $mixin: [
            {
              configSet: ConfigurableBackground,
            },
          ],
        },
        meetingName: {
          textStyles: {
            $mixin: [
              {
                configSet: ConfigurableText,
              },
            ],
          },
        },
        raceStatus: {
          textStyles: {
            $mixin: [
              {
                configSet: ConfigurableText,
              },
            ],
          },
        },
      },
    },
    layout: 'columnLayout',
    _mobile_layout: 'columnLayout',
    countdownMinutes: 10,
    baseButtonWidth: 80,
    _mobile_baseButtonWidth: 85,
    maxButtonsInRow: 9,
    _mobile_maxButtonsInRow: 4,
    buttonSpacing: '4px',
    raceButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            minHeight: '40px',
          },
        },
      },
    },
    raceButtonIconPosition: {
      top: '0px',
      padding: '0 0 0 4px',
    },
    nextRaceRightIcon: {
      configSet: Image,
      configValues: {
        src: 'chevron-right',
        style: {
          fill: '#283e56',
          minWidth: '14px',
          minHeight: '10px',
          padding: '0 0 0 8px',
        },
      },
    },
    liveRaceButtonIcon: {
      configSet: Image,
      configValues: {
        src: 'start-time',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    finishedRaceButtonIcon: {
      configSet: Image,
      configValues: {
        src: 'post',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    bestOddsRaceButtonIcon: {
      configSet: Image,
      configValues: {
        src: 'racing-bestodds',
        style: {
          minWidth: '14px',
          minHeight: '14px',
          padding: '2px 0 0 0',
        },
      },
    },
    pricedRaceButtonIcon: {
      configSet: Image,
      configValues: {
        src: 'racing-price',
        style: {
          minWidth: '14px',
          minHeight: '14px',
          padding: '2px 0 0 0',
        },
      },
    },
    meetingNameContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          alignItems: 'center',
          flexGrow: 0,
        },
      },
    },
    streamingIndicator: {
      configSet: Image,
      configValues: {
        src: 'streaming',
        style: {
          minWidth: '12px',
          minHeight: '12px',
        },
      },
    },
    raceStartTimeFormat: {
      configSet: DateTime,
      configValues: {
        format: 'SHORT_TIME',
      },
    },
    raceButtonStartTime: {
      configSet: DateTime,
      configValues: {
        format: 'SHORT_TIME',
      },
    },
    countdownContainer: {
      configSet: FlexPane,
      configValues: {
        separator: {
          style: {
            size: '2px',
          },
        },
      },
    },
    countdownTime: {
      configSet: Timer,
      configValues: {
        timerFourDigits: {
          timeBox: {
            style: {
              minWidth: '38px',
            },
          },
        },
      },
    },
    countdownText: {
      configSet: Text,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
